import React, { useEffect, useState } from "react";
import { Grid, Button, Card, Switch, FormControlLabel } from '@material-ui/core';
import { useSelector, useDispatch } from "react-redux";
import { MATERIALES } from "../../../../utils/permisos";
import ModalAbm from '../../../compartidos/abms/ModalAbm';
import BuscadorAbm from "../../../compartidos/abms/BuscadorAbm";
import TableGeneric from "../../../compartidos/abms/TableGeneric";
import AccionesGenericoAbm from "../../../compartidos/abms/AccionesGenericoAbm";
import { makeStyles } from "@material-ui/core/styles";
import { fetchMateriales, guardarMaterial, eliminarMaterial } from "../../../../actions/autorizaciones/abmMateriales";
import FormMateriales from "./FormMateriales";
import { useForm } from "../../../../hooks/useForm";
import moment from 'moment';


const useStyles = makeStyles({
  botonera: {
    padding: 25
  }
});

const stateInitial = {
    selectedMaterialActivo: false
};

export const HomeMateriales = (props) => {
  const { items = [] } = useSelector((state) => state.abmMateriales);

  const dispatch = useDispatch();
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [openModalAlta, setOpenModalAlta] = useState(false);
  const [itemForm, setItemForm] = useState(false);

  const [formValues, , , setearValor] = useForm(stateInitial);
  const { selectedMaterialActivo } = formValues;

  useEffect(() => {
    dispatch(fetchMateriales(null, selectedMaterialActivo));
  }, [dispatch, selectedMaterialActivo]);

  const handleSearch = (textoBuscado) => {
    dispatch(fetchMateriales(textoBuscado === "" ? null : textoBuscado, selectedMaterialActivo));
  }

  const handleItemSelect = (item) => {
    setItemForm(item)
    setOpen(true)
  }

  const handleSave = (item) => {
    const data = {
      codigoNum: item.codigoNum,
      codigo: item.codigo,
      descripcion: item.descripcion,
      sur: item.sur
    }

    dispatch(guardarMaterial(item.codigoNum, data));
  
  };

  const handleDelete = (item) => {

    dispatch(eliminarMaterial(item.codigoNum));
  }

  const intialValue = {
    codigoNum : 0,
    codigo: "",
    descripcion: "",
    sur: false
  }

  return (
    <div>
      <Grid container justify="center">
        <ModalAbm title="Agregar Material" open={openModalAlta} setOpen={setOpenModalAlta}>
          <FormMateriales formData={intialValue} handleSave={handleSave} cerrarModal={() => setOpenModalAlta(false)} permisoAlta={MATERIALES.ALTA} editando={false} />
        </ModalAbm>
        <ModalAbm title="Modificar Material" open={open} setOpen={setOpen}>
          <FormMateriales formData={itemForm} handleSave={handleSave} cerrarModal={() => setOpen(false)} permisoEdit={MATERIALES.MODIFICACION} editando={true} />
        </ModalAbm>
        <Grid item xs={12}>
          <Button variant="contained" color="primary" onClick={() => setOpenModalAlta(true)} style={{ float: "right", marginTop: "1rem" }}>+ Agregar Material</Button>
        </Grid>
        <Grid item xs={12} md={5} className={classes.root}>
          <BuscadorAbm title="Buscar Material" handleSearch={handleSearch} />
        </Grid>

        <Grid item xs={12} md={3} className={classes.root} style={{marginTop: "55px", marginLeft: "110px"}}>
          <FormControlLabel
            control={
              <Switch
                checked={selectedMaterialActivo}
                onChange={(e) => setearValor("selectedMaterialActivo", e.target.checked)}
              />
            }
            label="Mostrar Inactivos"
          />
        </Grid>


        <Grid item xs={12} md={9} style={{ marginTop: "2rem" }} >
          <Card>
            <TableGeneric
              data={items}
              columns={[
                {
                  label:"",
                  customBody:(item) => (
                    <AccionesGenericoAbm
                      item={item}
                      handleItemSelect={handleItemSelect}
                      permisoDelete={MATERIALES.BAJA}
                      handleDelete={handleDelete}
                      showSelect={item.fechaBaja === null}
                      showDelete={item.fechaBaja === null}
                    />
                  )
                },
                {
                  label: "Código",
                  id: "codigo",
                  sort: true
                },
                {
                  label: "Nombre",
                  id: "descripcion",
                  sort: true
                },
                {
                  label: "SURGE",
                  id: "sur",
                  sort: true,
                  customBody: (item) => (
                    <Switch
                      checked={item?.sur}
                      value={item?.sur}
                      name="sur"
                      classes={{ switchBase: classes.switchBase, checked: classes.checked, track: classes.track }}
                    />
                  ),
                },
                {
                  label: "Fecha baja",
                  id: "fechaBaja",
                  sort: true,
                  customBody: (item) => item.fechaBaja ? moment(item.fechaBaja).format('DD/MM/YYYY') : ""
                },

              ]}
            />
          </Card>
        </Grid>
      </Grid>
    </div>
  );

};

export default HomeMateriales; 
